import "./index.css";
import YieldFarmingCalculator from "./YieldFarmingCalculator";

export function App() {
  return <YieldFarmingCalculator />;
}

export default App;
